import { endpoint, siteID } from "./config.js";

export async function fetchSite() {
    const response = await fetch(endpoint + "/api/v2/site/" + siteID);
    return await response.json();
}

export async function fetchBlocks(pageID) {
    const response = await fetch(endpoint + "/api/v2/site/" + siteID + "/pages/" + pageID + "/blocks");
    return await response.json();
}

export async function fetchAllBlocks() {
    const response = await fetch(endpoint + "/api/site_blocks/" + siteID);
    return await response.json();
}

export async function fetchBlock(pageID, blockID) {
    const response = await fetch(endpoint + "/api/v2/site/" + siteID + "/pages/" + pageID + "/blocks/" + blockID);
    return await response.json();
}

export function debugOn() {
    let queryParams = new URLSearchParams(window.location.search);
    return queryParams.has('debug');
}

export function pages(site) {
    return safe(() => site['pages']) || [];
}

export function block(container, name) {
    return safe(() => container['blocks'][name]) || {};
}

export function blocklist(block, name) {
    return safe(() => block['blocklists'][name]['blocks']) || [];
}

export function image(block, name, size = [null, null]) {
    var content = safe(() => block['contents'][name]) || {};
    switch (content['mime']) {
      case 'image/svg':
            return content['image'];
      case 'image/jpg':
      case 'image/jpeg':
      case 'image/png':
      case 'image/tiff':
          var [w, h] = size.map(x => x ? x : "_");
          return content['image'] + "?" + "d=" + w + "x" + h;
      default:
          console.warn("Unsuported MIME: " + content['mime'] + " for " + name);
          return null;
    }
}

export function text(block, name) {
    return safe(() => block['contents'][name]['text']) || "";
}

export function richtext(block, name) {
    return safe(() => block['contents'][name]['richtext']) || "";
}

export function url(block, name) {
    return safe(() => block['contents'][name]['url']) || "#";
}

export function safe(f) {
    try {
        return f();
    } catch(e) {
        return undefined;
    }
}

export function exists(block, name) {
    return block['contents'][name] !== undefined;
}

export function video(block, name, size = 'orig') {
    return safe(() => block['contents'][name]['video'][size]) || "#";
}

export function style(block, rest = "") {
    let padding = () => {
        let default_pads = [5, 0, 5, 0];
        let block_pads;
        try {
            block_pads = block.style.padding;
        }
        catch(e) {
            block_pads = [0, 0, 0, 0];
        }
        let final_pads = [];
        for(let i = 0; i < default_pads.length; i++){
            final_pads.push(default_pads[i] + block_pads[i]);
        }
        return "padding:" + final_pads.join("em ");
    };

    return [padding(), rest].join(";");
}
